import { render, staticRenderFns } from "./KonsulAntarPoli.vue?vue&type=template&id=56e83c86"
import script from "./KonsulAntarPoli.vue?vue&type=script&lang=js"
export * from "./KonsulAntarPoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e83c86')) {
      api.createRecord('56e83c86', component.options)
    } else {
      api.reload('56e83c86', component.options)
    }
    module.hot.accept("./KonsulAntarPoli.vue?vue&type=template&id=56e83c86", function () {
      api.rerender('56e83c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/KonsulAntarPoli.vue"
export default component.exports